<template>  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header" class="row">
            <div class="col-6">
              <h4 class="card-title f-20-mobile">Usuários</h4>
            </div>
            <div class="col-6 text-right">
              <router-link to="/usuarios/novo" class="btn btn-primary">Novo</router-link>
            </div>
          </div>
          <input class="pull-right form-control dont-float-mobile" placeholder="Pesquisar..." v-debounce:250ms="search" v-model="query" style="max-width: 200px">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Documento</th> 
                <th>Grupo Empresarial</th> 
                <th class="text-right"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="usuario of users">
                <td>{{ usuario.name }}</td>
                <td>{{ usuario.cpf }}</td>
                <td><a href="somegoodfuckingurl.com">{{ usuario.group ? usuario.group.name : '' }}</a></td>
                <td class="text-right">
                  <router-link :to="{ path: '/usuarios/editar/' +  usuario.id, params: { userData: usuario, user: usuario } }" class="btn btn-sm btn-primary">
                    <i class="fa fa-pencil"></i>
                  </router-link>
                </td>
              </tr>
              <tr v-if="!users || !users.length">
                <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-12 col-md-6 text-center-mobile">
              Mostrando de {{ from }} até {{ to }} de {{ total}} registros
            </div>
            <div class="col-12 col-md-6 text-right text-center-mobile mt-2-mobile">
              <paginate
                :pageCount="pageCount"
                :clickHandler="changePage"
                :prevText="'Ante.'"
                :nextText="'Próx.'"
                :containerClass="'pagination'">
              </paginate>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
  } from 'src/components'
import moment from 'moment'
import UserService from '@/services/UserService.js'

export default {
    components: {
      Card,
      moment
    },
    data() {
      return {
        users: [],
        total: 0,

        from: 0,
        to: 0,
        current_page: 1,
        pageCount: 0,
        query: ''
      }
    },
    methods:{

      changePage(page) {
        this.current_page = page
        this.loadUsers()
      },

      filtrar() {
        this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment(this.data_inicio).format('DD/MM/YYYY');
        this.loadUsers()
      },
      loadUsers() {
        UserService.load(`?page=${this.current_page}` + "&query=" + this.query).then(res => {
          console.log(res.data.data)
          this.pageCount = res.data.last_page
          this.users = res.data.data
          this.from = res.data.from
          this.to = res.data.to
          this.total = res.data.total; 
        }).catch(err => {
          console.error(err)
        })
      },

      getUnidade(unidade) {
        let unidades = [  
          "UN",
          "CT",
          "CX",
          "DZ",
          "GZ",
          "PA",
          "PC",
          "PR",
          "PT",
          "RL",
          "KG",
          "G",
          "SC60",
          "L",
          "M3",
          "M2",
          "CM2",
          "M",
          "CM",
          "X"
        ]

        console.log(unidades[unidade])
        return unidades[unidade];
      },
      search() {
        this.current_page = 1
        this.loadUsers()
      },
    },
    mounted() {
      this.loadUsers()
    }
}
</script>

<style>
  .status {
    display: inline-block; margin-right: 6px;
  }
  .status.danger {
    background-color: red;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
  .status.alive {
    background-color: #26de81;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
  .status.warning {
    background-color: #fed330;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
</style>  